import { IconButton } from "@mui/material";
import React from "react";
import PrintIcon from "./icon/PrintIcon";

export default function PrintBtn({ handlePrint, ...props }) {
  return (
    <IconButton
      disabled={props?.disabled}
      sx={{ width: "32px", height: "32px", background: "var(--grey) !important", color: props.disabled ? "#b0b0b0" : "#000" }}
      onClick={handlePrint}
    >
      <PrintIcon color="currentColor" />
    </IconButton>
  );
}
